<template>
  <input type="button" class="btn" value="Pageを表示" v-on:click="showPages">
  <div class="page-item-wrapper">
    <div class="page-item" v-for="page in pages" v-bind:key="page.key">
      <div class="img-box" v-on:click="toPageDetail(page.PageId)">
        <img v-bind:src=makeImgPath(page)>
      </div>
      <div class="page">
        {{ page.PageNum }}
      </div>
      <div class="regi-thumb">
        <button class="btn" type="button" v-on:click="registerThumb(page.PageId, makeImgPath(page))">thumb</button>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";

import axios from "axios";
import store from "@/store";
import makeThumbPath from "@/script/MakeThumbPath";
import authCheck from "@/script/AuthCheck";

export default {
  name: 'ListPage',
  components: {},
  props: [""],
  data: function () {
    return {
      pages: {},
      detailPath: "/page"
    }
  },
  methods: {
    showPages() {
      const textbook_id = store.getters.textbookId
      let path = '/pages?id=' + textbook_id
      axios.get(path, {withCredentials: true})
          .then(res => {
            console.log(res)
            this.pages = res.data.list
          })
    },
    toPageDetail: function (id){
      this.$router.push(this.detailPath + '?id=' + id)
    },
    makeImgPath(page) {
      let path = ""
      let data = {}
      data.id = store.getters.textbookId
      data.hash = page.Hash
      data.extension = page.Extension
      path = makeThumbPath(data)
      return path
    },
    registerThumb(page_id, thumbPath) {
      const textbook_id = store.getters.textbookId
      let path = '/registertextthumb'
      const params = new URLSearchParams();
      params.append('textbook_id', textbook_id)
      params.append('page_id', page_id)
      axios.post(path, params, {withCredentials: true})
          .then(res => {
            if (res.data.result === true) {
              window.alert("サムネイルを登録しました")
              this.setStoreImageId(parseInt(res.data.imageId))
              this.setTextThumbImgPath(thumbPath)
            } else {
              const router = this.$router
              authCheck(res, router)
              window.alert("サムネイルの登録に失敗しました")
            }
          })
          .catch(function (error) {
            console.log(error)
            window.alert("通信に失敗しました。もう一度行ってください")
          })
    },
    setStoreImageId(imageId){
      store.commit('setTextThumbImageId', (store, imageId))
    },
    setTextThumbImgPath(path){
      store.commit('setTextThumbImagePath', (store, path))
      return true
    },
    getTextThumbImageId(){
      return store.getters.textThumbImageId
    },
    getTextThumbImagePath(){
      return store.getters.textThumbImagePath
    },
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-item-wrapper {
  width: 100%;
}

.page-item {
  border: #20a0ff 1px solid;
  border-radius: 0.5rem;
  margin-left: 10px;
  margin-bottom: 10px;
  padding: 0.3rem;
  width: 130px;
  float: left;
}

.img-box {
}

.img-box img {
  object-fit: contain;
  width: 120px;
  height: 160px;
  border: gray 1px solid;
}

.page-item .page {
  text-align: center;
}
</style>
